module.exports = " <div class=calendar> <calendar-controls></calendar-controls> <div class=row> <div class=\"column shrink\"> <calendar-timeline></calendar-timeline> </div> <tooltip></tooltip> <div class=column> <router-view class=\"view wrapper\" keep-alive transition=app transition-mode=out-in> </router-view> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/CalendarView.vue
// module id = 343
// module chunks = 2